import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { FieldProps } from "formik";
import { DateTime } from "luxon";
import DatePicker from "react-datepicker";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const insertFormat = "yyyy-MM-dd";

const DateInputFloating: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  onChange,
  ...props
}) => {
  const [internal, setInternal] = useState(value ? DateTime.fromFormat(value, "yyyy-MM-dd").toJSDate() : new Date())
  
  useEffect(() => {
    if(onChange) {
      onChange()
    }
  }, [value, onChange]);

  return (
    <Form.Group>
      <DatePicker
        selected={internal}
        dateFormat="dd MMM yyyy"
        onChange={date => {
          if (date) {
            setInternal(date);
          }
          setFieldValue(
            name,
            date ? DateTime.fromJSDate(date).toFormat(insertFormat) : ""
          );
        }}
        customInput={
          <div className="f-group">
            <input 
            type="text" 
            id={props.id} 
            name={name}
            autoComplete="off"
            placeholder={props.placeholder}
            className="form-control react-datepicker-ignore-onclickoutside"
            value={value}
            disabled={props.disabled}
            />
            {props.label && (
              <Form.Label htmlFor={props.id} className="f-label">
                {props.required ? <b>{props.label}</b> : props.label}
                {props.required && <span className="text-danger">*</span>}
              </Form.Label>
            )}
          </div>
        }
        {...props}
      />
      {/* } */}
      
      {touched[name] && errors[name] ? (
        <Form.Text className="invalid-feedback">{errors[name]}</Form.Text>
      ) : (
          ""
      )}
    </Form.Group>
  );
};

export default DateInputFloating;
